const avisosRecomendadosIA = {
  listado: {
    cta: '¿No sabés qué buscar? <0>Mirá los empleos recomendados por IA</0> (Beta)',
  },
}

export default avisosRecomendadosIA
